import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsService } from 'src/app/common/services/utils.service';
import { InMemoryCacheService } from 'src/app/common/cache/in-memory-cache.service';
import { Event } from 'src/app/common/events/event-base';
import { BacklinksOptions } from 'src/app/pages/seo/models/site-search-filter-options';
import { SeoApiService } from 'src/app/pages/seo/seo-api.service';
import { SiteSearchService } from 'src/app/pages/seo/site-search/site-search.service';
import { BaseSearchResultsComponent } from '../base-search-results/base-search-results.component';
import { DynamicDialogRef, DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { BacklinksResultsComponent } from '../backlinks-results/backlinks-results.component';
import { BacklinksRequest } from 'src/app/pages/seo/models/site-search-request';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { TruncatePipe } from 'src/app/common/pipes/truncate.pipe';

@Component({
  selector: 'gig-referring-domains-results',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, TooltipModule, DynamicDialogModule, TranslateModule, TruncatePipe, BacklinksResultsComponent],
  templateUrl: './referring-domains-results.component.html',
  styleUrls: ['./referring-domains-results.component.scss']
})
export class ReferringDomainsResultsComponent extends BaseSearchResultsComponent implements OnInit {

  public selectedBacklink: any;
  private dialogRef: DynamicDialogRef | undefined;
  @Output() pageChanged: EventEmitter<ReferringDomainEvent> = new EventEmitter<ReferringDomainEvent>();
  @Output() backlinkClicked: EventEmitter<any> = new EventEmitter<any>();


  constructor(public utils: UtilsService, public cache: InMemoryCacheService, public seoApiService: SeoApiService, 
    public siteSearchService: SiteSearchService, private dialogService: DialogService) {
    super(utils);
   }

  ngOnInit(): void {
    this.cols = [
      {field: 'referringPage', header: 'Referring Page'},
      {field: 'rank', header: 'Rank'},
      {field: 'externalLinks', header: 'External Links'},
      {field: 'new', header: 'New'},
      {field: 'broken', header: 'Broken'},
      {field: 'anchor', header: 'Anchor'},
      {field: 'firstSeen', header: 'First Seen'}
    ]
  }

  public async onBacklinkClicked(row: any) {
    this.utils.logger.info('ReferringDomainsResultsComponent.onBacklinkClicked()');

      const filter: string = `["domain_from", "=", "${row.domain}"]`;

      const backlinkRequest: BacklinksRequest =  {
      "target": this.utils.stripHost(this.target),
      "mode": 'as_is',
      "filtersString": filter,
      "limit": this.cache.seoLimits.referringDomainsBacklinks,
    }

    this.cache.loading = true;
    const { data, error } = await this.seoApiService.getBacklinks(backlinkRequest);
    this.cache.loading = false;

    this.dialogRef = this.dialogService.open(BacklinksResultsComponent, {
      header: `Top 10 Backlinks from ${row.domain}`,
      draggable: true,
      width: '50vw',
      data: data.items,
      resizable: true,
      maximizable: true
    });
    
  }

  public onPageChanged(e: any): void {
    this.utils.logger.info('ReferringDomainsResultsComponent.onPageChanged() ');
    this.pageChanged.emit(new ReferringDomainEvent('ReferringDomainsResultsComponent.PAGE_CHANGED', e));
  }

}

export class ReferringDomainEvent extends Event {
  constructor(type: string, payload: any) {
    super(type, payload);
  }
}
